import { useState } from "react";
import { Search, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const EMPTY = { year: "", make: "", model: "", part: "", part_number: "" };

const Cell = ({ label, className = "", ...props }) => (
  <label className={`flex flex-col gap-1 px-4 py-3 border-border ${className}`}>
    <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">{label}</span>
    <Input className="h-8 border-0 bg-transparent p-0 text-base focus-visible:ring-0 placeholder:text-slate-700 placeholder:italic" {...props} />
  </label>
);

export const SearchForm = ({ onSearch, busy, initial }) => {
  const [q, setQ] = useState(initial || EMPTY);
  const set = (k) => (e) => setQ({ ...q, [k]: e.target.value });
  const canSearch = Object.values(q).some((v) => v.trim());

  const submit = (e) => {
    e.preventDefault();
    if (canSearch && !busy) onSearch(q);
  };

  return (
    <form onSubmit={submit} data-testid="part-search-form"
      className="bg-card/90 border border-border rounded-sm shadow-2xl backdrop-blur-md focus-within:border-primary transition-colors">
      <div className="grid grid-cols-2 md:grid-cols-12 divide-border">
        <Cell label="Year" className="md:col-span-2 border-b md:border-r" value={q.year} onChange={set("year")} placeholder="e.g. 2014" maxLength={10} data-testid="search-year-input" />
        <Cell label="Make" className="md:col-span-3 border-b border-l md:border-l-0 md:border-r" value={q.make} onChange={set("make")} placeholder="e.g. Ford" data-testid="search-make-input" />
        <Cell label="Model" className="col-span-2 md:col-span-3 border-b md:border-r" value={q.model} onChange={set("model")} placeholder="e.g. Cascadia, F-150" data-testid="search-model-input" />
        <Cell label="Part number" className="col-span-2 md:col-span-4 border-b" value={q.part_number} onChange={set("part_number")} placeholder="e.g. BL3Z-6731-A" data-testid="search-partnumber-input" />
      </div>
      <div className="flex flex-col sm:flex-row">
        <Cell label="What part? (optional)" className="flex-1" value={q.part} onChange={set("part")} placeholder="e.g. front brake pads" data-testid="search-part-input" />
        <div className="p-3 flex items-center">
          <Button type="submit" disabled={!canSearch || busy} data-testid="part-search-submit-btn"
            className="w-full sm:w-auto h-12 px-8 rounded-sm font-semibold uppercase tracking-wider hover:bg-orange-600 hover:text-white">
            {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Search className="h-4 w-4 mr-2" />}
            {busy ? "Searching" : "Search web"}
          </Button>
        </div>
      </div>
    </form>
  );
};
